import PageHeader from "components/Page/PageHeader";
import { Box, Flex } from "@chakra-ui/react";
import NewTable from "components/NewTable";
import HeaderTable from "components/Page/HeaderTable";
import SelectableButton from "components/Button/SelectableButton";
import useFiltroOrcamentos from "./hooks/useFiltroOrcamentos";
import colors from "core/resources/theme/colors";
import useOrcamentosColumns from "./hooks/useOrcamentosColumns";
import { StatusOrcamentoEnum } from "core/features/orcamento/typings";
import { useListarOrcamentos } from "core/features/orcamento/hooks/useListarOrcamentos";
import history from "infra/helpers/history";
import { PermissaoEnum } from "core/resources/enums/permissao";
import {
  MdDescription,
  MdOutlineAttachMoney,
  MdHistory,
  MdDelete,
} from "react-icons/md";
import {
  TabsMenuOptionsRoutes,
  TabMenuOptions,
} from "../../../Detalhes/typings";
import useDeleteOrcamento from "core/features/orcamento/hooks/useDeleteOrcamento";
import { showConfirm } from "infra/helpers/alerta";
import { useState } from "react";
import ModalHistoryOrcamento from "./../ModalHistoryOrcamento";

export default function ListaOrcamentos() {
  const { filtro, onChangeFiltro } = useFiltroOrcamentos();
  const columns = useOrcamentosColumns();
  const { data, isLoading, refetch, isFetching } = useListarOrcamentos(filtro);
  const { mutate: handleDelete, isLoading:isLoadingDelete } = useDeleteOrcamento();
  const [historyId, setHistoryId] = useState<string>();

  const onUnselect = () => onChangeFiltro({ statusId: undefined });

  const _isLoading = isLoading || isFetching || isLoadingDelete;

  return (
    <>
      <PageHeader
        title="Aquisição de Bens e Serviços"
        mb="24px"
        titleButton="Novo orçamento"
        onClick={() => history.push("/administracao/orcamento/novo")}
        permissions={[PermissaoEnum.Backoffice.Administrativo.Orcamento.Criar]}
      />

      <Box>
        <NewTable<any>
          title={() => (
            <HeaderTable
              searchMinW="400px"
              childrenFlex={0}
              value={filtro.search || ""}
              onSearch={(v) => onChangeFiltro({ search: v })}
            >
              <Flex flex={1} justifyContent="flex-start" gridGap="16px">
                <SelectableButton
                  selected={
                    filtro.statusId === StatusOrcamentoEnum.PendenteAprovacao
                  }
                  onClick={() => {
                    onChangeFiltro({
                      statusId: StatusOrcamentoEnum.PendenteAprovacao,
                    });
                  }}
                  onUnselect={onUnselect}
                  rounded="full"
                  selectedColor={colors.red}
                  fontSize="14px"
                >
                  Pendente de aprovação
                </SelectableButton>
                <SelectableButton
                  selected={
                    filtro.statusId === StatusOrcamentoEnum.ConsultaFornecedor
                  }
                  onClick={() => {
                    onChangeFiltro({
                      statusId: StatusOrcamentoEnum.ConsultaFornecedor,
                    });
                  }}
                  onUnselect={onUnselect}
                  rounded="full"
                  selectedColor={colors.orange}
                  fontSize="14px"
                >
                  Em consulta de fornecedor
                </SelectableButton>
                <SelectableButton
                  selected={filtro.statusId === StatusOrcamentoEnum.Aprovado}
                  onClick={() => {
                    onChangeFiltro({ statusId: StatusOrcamentoEnum.Aprovado });
                  }}
                  onUnselect={onUnselect}
                  rounded="full"
                  selectedColor={colors.green500}
                  fontSize="14px"
                >
                  Aprovado
                </SelectableButton>
              </Flex>
            </HeaderTable>
          )}
          columns={columns}
          dataSource={data?.items || []}
          loading={_isLoading}
          customPagination={{
            currentPage: data?.meta.currentPage ?? 1,
            totalItems: data?.meta.totalItems ?? 0,
            itemsPerPage: data?.meta.itemsPerPage ?? 10,
            onChangePage: (page, limit) => onChangeFiltro?.({ page, limit }),
          }}
          actions={[
            ...TabMenuOptions.map((option) => ({
              title: option.label,
              icon: () => {
                if (option.route === TabsMenuOptionsRoutes.Dados) {
                  return <MdDescription size={22} />;
                }
                return <MdOutlineAttachMoney size={22} />;
              },
              onClick: (v: any) => {
                history.push(
                  `/administracao/orcamento/${v.id}?opcao=${option.route}`
                );
              },
              permission: option.permission,
            })),
            {
              title: "Histórico",
              icon: () => <MdHistory size={22} />,
              onClick: (v) => {
                setHistoryId(v.id);
              },
            },
            {
              title: "Excluir",
              color: "red",
              icon: () => <MdDelete size={22} />,
              permission:
                PermissaoEnum.Backoffice.Administrativo.Orcamento.Excluir,
              onClick: (v) =>
                showConfirm("Deseja realmente excluir esse orçamento?").then(
                  ({ isConfirmed }) => {
                    if (isConfirmed) {
                      handleDelete(v.id, {
                        onSuccess: () => refetch?.(),
                      });
                    }
                  }
                ),
            },
          ]}
        />
      </Box>

      {historyId ? (
        <ModalHistoryOrcamento
          isOpenModal={!!historyId}
          onClose={() => {
            setHistoryId(undefined);
          }}
          orcamentoId={historyId}
        />
      ) : null}
    </>
  );
}
